if (!customElements.get("product-request-information")) {
  customElements.define(
    "product-request-information",
    class ProductRequestInformation extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.collapsed = this.getAttribute("expanded") === "false";
        this.toggleElement = this.querySelector(".product-request-information-toggle");
        this.content = this.querySelector(".product-request-information-content");

        this.content.style.overflow = "hidden";
        this.content.style.transition = "max-height 0.5s ease";
        this.content.style.maxHeight = this.collapsed ? "0" : `${this.content.scrollHeight}px`;

        this.onToggle = this.onToggle.bind(this);
        this.toggleElement.addEventListener("click", this.onToggle);
      }

      onToggle(event) {
        event.preventDefault();
        this.handleToggle();
      }

      collapse() {
        this.setAttribute("expanded", "false");
        this.toggleElement.setAttribute("aria-expanded", "false");
        this.content.style.maxHeight = "0";
        this.collapsed = true;
      }

      expand() {
        this.setAttribute("expanded", "true");
        this.toggleElement.setAttribute("aria-expanded", "true");
        this.content.style.maxHeight = `${this.content.scrollHeight}px`;
        this.collapsed = false;
        this.querySelector('input[name="contact[first_name]"]')?.focus();
      }

      handleToggle() {
        if (this.collapsed) {
          this.expand();
        } else {
          this.collapse();
        }
      }
    },
  );
}